
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"72","height":"72","viewBox":"0 0 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#36AE61","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"4.5","transform":"translate(2 2)"}},[_c('path',{attrs:{"d":"M58.756 25V13.747a4.5 4.5 0 00-4.5-4.5h-12m-25.5 0h-12a4.5 4.5 0 00-4.5 4.5v49.5a4.5 4.5 0 004.5 4.5H29.5"}}),_c('path',{attrs:{"d":"M41.269 12.208a2.253 2.253 0 01-2.133 1.539H19.879c-.969 0-1.829-.62-2.136-1.539l-3-9A2.247 2.247 0 0116.879.247h25.257a2.247 2.247 0 012.133 2.961l-3 9zM22.756 58.747H11.5a2.25 2.25 0 01-2.25-2.25v-38.25m40.506 0v4.5"}}),_c('circle',{attrs:{"cx":"49.75","cy":"49.747","r":"18"}}),_c('path',{attrs:{"d":"M49.75 40.747v18m-9-9h18m-40.494-22.5h13.5m-13.5 13.5h4.5"}})])])
          )
        }
      }
    